import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

// Connects to data-controller="combo-chart"
// Renders a combo chart with bars (trees) and line (avg time) on dual y-axes
export default class extends Controller {
  static targets = ["canvas"]
  static values = {
    barData: Object,
    lineData: Object,
    barLabel: String,
    lineLabel: String,
    barColor: { type: String, default: "#3b82f6" },
    lineColor: { type: String, default: "#f59e0b" }
  }

  connect() {
    this.renderChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  renderChart() {
    const ctx = this.canvasTarget.getContext("2d")
    const labels = Object.keys(this.barDataValue)

    const barValues = labels.map(label => this.barDataValue[label] || 0)
    const lineValues = labels.map(label => this.lineDataValue[label])

    this.chart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: labels,
        datasets: [
          {
            type: "bar",
            label: this.barLabelValue,
            data: barValues,
            backgroundColor: this.barColorValue,
            borderColor: this.barColorValue,
            borderWidth: 1,
            yAxisID: "y",
            order: 2
          },
          {
            type: "line",
            label: this.lineLabelValue,
            data: lineValues,
            borderColor: this.lineColorValue,
            backgroundColor: this.lineColorValue + "33",
            borderWidth: 3,
            pointRadius: 4,
            pointHoverRadius: 6,
            tension: 0.3,
            fill: false,
            yAxisID: "y1",
            order: 1
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          mode: "index",
          intersect: false
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: { font: { size: 10 } }
          },
          y: {
            type: "linear",
            position: "left",
            beginAtZero: true,
            title: {
              display: true,
              text: this.barLabelValue,
              color: this.barColorValue,
              font: { size: 11, weight: "bold" }
            },
            ticks: {
              color: this.barColorValue,
              font: { size: 10 }
            },
            grid: { color: "#f0f0f0" }
          },
          y1: {
            type: "linear",
            position: "right",
            beginAtZero: true,
            title: {
              display: true,
              text: this.lineLabelValue + " (min)",
              color: this.lineColorValue,
              font: { size: 11, weight: "bold" }
            },
            ticks: {
              color: this.lineColorValue,
              font: { size: 10 },
              callback: (value) => value + " min"
            },
            grid: { display: false }
          }
        },
        plugins: {
          legend: {
            display: true,
            position: "bottom",
            labels: {
              boxWidth: 12,
              font: { size: 11 },
              usePointStyle: true
            }
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                const label = context.dataset.label || ""
                const value = context.parsed.y
                if (context.datasetIndex === 1) {
                  return `${label}: ${value != null ? value.toFixed(2) + " min" : "-"}`
                }
                return `${label}: ${value}`
              }
            }
          }
        }
      }
    })
  }
}

